<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<button-search ref="buttonSearch" placeholder="要搜索的商品名称" @search="searchEvent" class="pt-3 pb-1">
			<!-- 左边 -->
			<template #left>
				<el-button type="primary" size="mini" icon="el-icon-plus" @click="navigate('scgl_zjhrk_cprk_create')">下单</el-button>
				<el-button type="danger" size="mini" icon="el-icon-delete">删除</el-button>
				<el-button type="primary" size="mini" @click="opcta(multipleSelection)" icon="el-icon-s-promotion">发送消息</el-button>
				<el-dropdown class="ml-2 mr-2">
					<el-button type="success" icon="el-icon-s-promotion" size="mini">审核</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item><div style="color: #7c7eff;font-size: 12px;" @click="states(1, multipleSelection)">同意</div></el-dropdown-item>
						<el-dropdown-item><div style="color: #d00003;font-size: 12px;" @click="states(2, multipleSelection)">拒绝</div></el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-button type="success" size="mini" @click="rkqr(multipleSelection)" icon="el-icon-position">入库确认</el-button>
			</template>

			<!-- 高级搜索表单 -->
			<template #form>
				<el-form inline ref="form" :model="form" label-width="80px">
					<el-form-item label="商品名称" class="mb-0"><el-input v-model="form.title" placeholder="商品名称" size="mini"></el-input></el-form-item>
					<el-form-item label="商品分类" class="mb-0">
						<el-select v-model="form.category_id" placeholder="请选择商品分类" size="mini">
							<el-option v-for="item in cateOptions" :key="item.id" :label="item | tree" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="mb-0">
						<el-button type="info" size="mini" @click="searchEvent">搜索</el-button>
						<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
					</el-form-item>
				</el-form>
			</template>
		</button-search>

		<el-tabs v-model="tabIndex" @tab-click="getList">
			<el-tab-pane :key="tabI" v-for="(tab, tabI) in tabbars">
				<span slot="label" class="d-flex">
					<div style="">{{ tab.name }}</div>
					<div
						v-if="tab.num != 0"
						style="background: #ffa303;width: 24px;height: 18px;border-radius: 10px;margin-top: 6px;justify-content: center;align-items: center;"
						class="d-flex"
					>
						<div style="font-size: 10px;color: #fff;font-weight: 800;">{{ tab.num }}</div>
					</div>
				</span>
			</el-tab-pane>
		</el-tabs>

		<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" size="mini" :max-height="maxHeight">
			<el-table-column type="selection" width="45" align="center"></el-table-column>
			<el-table-column align="center" prop="id" width="50" label="编号" fixed="left"></el-table-column>
			<el-table-column type="expand" label="明细表" width="60">
				<template slot-scope="scope">
					<el-table :data="scope.row.scddcp" stripe style="padding-left: 100px;" size="mini" :header-cell-style="{ background: '#f4faf4' }">
						<el-table-column type="index" label="生产信息" width="90" align="center"></el-table-column>
						<el-table-column prop="cpmc" label="成品名称" width="160"></el-table-column>
						<el-table-column prop="cpbm" label="成品编码" width="100" align="center"></el-table-column>
						<el-table-column prop="ggmc" label="规格名称" width="100" align="center"></el-table-column>
						<el-table-column prop="ggbm" label="规格编码" width="100" align="center"></el-table-column>
						<el-table-column prop="dw" label="单位" width="80" align="center"></el-table-column>
						<el-table-column prop="sl" label="数量" width="80" align="center"></el-table-column>
					</el-table>
				</template>
			</el-table-column>
			<el-table-column align="center" width="110" label="生产单号">
				<template slot-scope="scope">
					{{ scope.row.scbh }}
				</template>
			</el-table-column>
			<el-table-column align="center" width="110" label="产品数量">
				<template slot-scope="scope">
					{{ scope.row.cpsl }}
				</template>
			</el-table-column>
			<el-table-column align="center" width="100" label="审核状态">
				<template slot-scope="scope">
					<el-button type="info" size="mini" plain v-if="scope.row.cpsh == 0">待审核</el-button>
					<el-button type="success" size="mini" plain v-else-if="scope.row.cpsh == 1">已审核</el-button>
					<el-button type="warning" size="mini" plain v-else>不通过</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="100" label="入库状态">
				<template slot-scope="scope">
					<el-button type="info" size="mini" plain v-if="scope.row.rkzt == 0">未处理</el-button>
					<el-button type="success" size="mini" plain v-else>已出库</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="170" label="仓库仓位">
				<template slot-scope="scope">
					<el-button type="success" size="mini" plain>{{ scope.row.ckcw.name }}</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="100" label="业务员">
				<template slot-scope="scope">
					<el-button type="success" size="mini" plain>{{ scope.row.ywy.name }}</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="130" label="创建时间">
				<template slot-scope="scope">
					{{ scope.row.create_time.slice(0, 10) }}
				</template>
			</el-table-column>
			<!-- 操作 -->
			<el-table-column align="center" label="操作" fixed="right" width="240">
				<template slot-scope="scope">
					<el-button type="primary" size="mini" @click="navigate('scgl_zjhrk_cprk_create', scope.row)">编辑</el-button>
					<el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="height: 60px;"></div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>
		<el-drawer title="企业微信消息发送" :visible.sync="drawera" :direction="direction" size="600px">
			<div class="ml-4 mr-4" style="width: 100%;">
				<el-form ref="form" label-width="80px">
					<el-form-item label="信息数量"><el-input v-model="form.xxsl" size="mini" style="width: 95%;"></el-input></el-form-item>
					<el-form-item label="标题字段">
						<el-select v-model="form.btzd" placeholder="请选择" size="mini">
							<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="消息标题"><el-input v-model="form.xxbt" size="mini" style="width: 95%;"></el-input></el-form-item>
					<el-form-item label="卡片描述">
						<el-select v-model="form.kpms" placeholder="请选择" size="mini">
							<el-option v-for="item in optionss" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="卡片链接"><el-input v-model="form.kplj" size="mini" style="width: 95%;"></el-input></el-form-item>
					<el-form-item label="接收对象">
						<el-radio-group v-model="form.jsdx" size="mini">
							<el-radio-button label="0">个人</el-radio-button>
							<el-radio-button label="1">部门</el-radio-button>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="选择范围">
						<el-select v-model="form.xzfw" filterable placeholder="请选择">
						    <el-option v-for="item in grlist" :key="item.id" :label="item.name" :value="item.id" v-if="form.jsdx == 0"></el-option>
							<el-option v-for="item in bmlist" :key="item.id" :label="item.name" :value="item.id" v-else></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
		</el-drawer>
	</div>
</template>

<script>
import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	// 引入注册
	components: {
		buttonSearch
	},
	data() {
		return {
			multipleSelection: [],
			preUrl: 'scwc',
			maxHeight: 0,
			tabIndex: 0,
			tableData: [],
			tabbars: [
				{ name: '全部订单', key: 'all', num: 0 },
				{ name: '待审核', key: 'dsh', num: 0 },
				{ name: '已审核', key: 'ysh', num: 0 },
				{ name: '不通过', key: 'btg', num: 0 },
				{ name: '待入库', key: 'drk', num: 0 },
				{ name: '已入库', key: 'yrk', num: 0 }
			],
			drawera: false,
			grlist: [],
			bmlist: [],

			form: {},

			cateOptions: [],
			value: '更多',
			drawer: false,
			drawerb: false,
			num: 99,
			drawera: false,
			options: [
				{
					id: 0,
					name: '订单号'
				},
				{
					id: 1,
					name: '商品总额'
				},
				{
					id: 2,
					name: '订单金额'
				},
				{
					id: 3,
					name: '待结算金额'
				},
				{
					id: 4,
					name: '产品数量'
				},
				{
					id: 5,
					name: '客户'
				},
				{
					id: 6,
					name: '审核状态'
				},
				{
					id: 7,
					name: '出库状态'
				},
				{
					id: 8,
					name: '收款状态'
				},
				{
					id: 9,
					name: '业务员'
				},
				{
					id: 10,
					name: '下单时间'
				}
			],
			optionss: [
				{
					id: 0,
					name: '您有新的消息，请点击进入详情查看。'
				},
				{
					id: 1,
					name: '您有新的订单，请及时处理。'
				},
				{
					id: 2,
					name: '您有新的工作，请查看。'
				}
			],
			direction: 'rtl',
		};
	},
	filters: {
		tree(item) {
			if (item.level == 0) {
				return item.name;
			}
			let str = '';
			for (let i = 0; i < item.level; i++) {
				str += i == 0 ? '|--' : '--';
			}
			return str + ' ' + item.name;
		}
	},
	computed: {
		...mapState({
			user: state => state.user.user
		}),
		tab() {
			return this.tabbars[this.tabIndex].key; //拿到key值，用来高级搜索
		},
		params() {
			let str = '';
			for (let key in this.form) {
				let val = this.form[key];
				if (val) {
					str += `&${key}=${this.form[key]}`;
				}
			}
			return str;
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 290;
		});
		this.axios
			.get('/admin/managers/list', {
				token: true
			})
			.then(res => {
				this.grlist = res.data.data;
			});
		this.axios
			.get('/admin/bumens/list', {
				token: true
			})
			.then(res => {
				this.bmlist = res.data.data;
			});
	},
	methods: {
		getList() {
			if (this.preUrl == '') return;
			this.showLoading();
			let url = this.getListUrl();
			this.axios
				.get(url, {
					// 商品规格 api
					token: true
				})
				.then(res => {
					let data = res.data.data;
					this.page.total = data.totalCount; // 获取分页信息
					console.log(data);
					this.getListResult(data); // 获取到的数据储存到getListResult(data)，方便外面调用修改
					this.tabbars[1].num = data.dsh;
					this.tabbars[4].num = data.drk;
					this.hideLoading();
				})
				.catch(err => {
					this.hideLoading();
				});
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		// 鼠标单击的事件
		navigate(name, e) {
			if (!e) {
				var data = 0;
				var ddlx = 1;
			} else {
				var ddlx = e.ddlx;
				var data = {
					scbh: e.scbh,
					ddlx: e.ddlx,
					desc: e.desc,
					ywy: e.ywy.id,
					jhkssj: e.jhkssj,
					jhwcsj: e.jhwcsj,
					scddcp: e.scddcp,
					sclx: e.sclx.id,
					scz: e.scz.id,
					xxdd: e.xxdd,
					sfwb: e.sfwb == 0 ? false : true,
					wbgys: e.wbgys.id,
					id: e.id,
					cjr: e.cjr.id
				};
			}
			this.$router.push({
				name,
				query: {
					ddlx: ddlx,
					data:data
				}
			});
		},
		
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&tab=${this.tab}${this.params}`;
		},
		getListResult(e) {
			this.tableData = e.list;
			this.cateOptions = e.cates;
		},

		clearSearch() {
			this.form = {
				title: '',
				category_id: ''
			};
		},
		searchEvent(e = false) {
			if (typeof e === 'string') {
				this.form.title = e;
			}
			this.getList();
		},
		
		opcta(f) {
			if (f.length == 0) {
				return this.$message({
					type: 'error',
					message: '请选择要操作的订单'
				});
			}else{
				this.form = {
					xxsl:f.length,
					btzd:0,
					xxbt:'',
					kpms:'',
					kplj:'',
					jsdx:0,
					xzfw:''
				}
				this.drawera = true;
			}
		},
		rkqr(e){
			if(e.length == 0){
				return this.$message({
					type: 'error',
					message: '请选择要操作的订单'
				});
			}else if(e.length > 1){
				return this.$message({
					type: 'error',
					message: '请选择一张订单'
				});
			}else if(e[0].rkzt == 1){
				return this.$message({
					type: 'error',
					message: '订单已完成入库'
				});
			}else {
				if(e[0].cpsh == 0){
					return this.$message({
						type: 'error',
						message: '订单未审核'
					});
				}else if(e[0].cpsh == 2){
					return this.$message({
						type: 'error',
						message: '订单审核不通过'
					});
				}else{
					let f = {
						cjr:this.user.id,
						scrq:e[0].scrq,
						cp:e[0].scddcp,
						id:e[0].id,
						gldlx:'成品入库',
						pch:e[0].pch,
						ckcw:e[0].ckcw.id,
						xxdd:e[0].xxdd
					}
					this.axios.post('/admin/scddrk/'+f.id, f,{
						token: true
					}).then(res => {
						this.getList();
						return this.$message({
							type: 'success',
							message: '入库成功'
						});
						
					})
				}
			}
		},
		states(e, f) {
			if (f.length == 0) {
				return this.$message({
					type: 'error',
					message: '请选择要操作的订单'
				});
			}else if (f[0].cpsh == 1) {
				return this.$message({
					type: 'error',
					message: '订单已完成审核'
				});
			}else{
				let x = f.map(i => {
					return i.id;
				});
				let i = {
					cpsh: e,
					ids: x,
					fsr:this.user.id
				};
				this.axios.post('/admin/scdd/rkupdate_status', i,{
					token: true
				}).then(res => {
					this.getList()
				})
			}
			
		},
	}
};
</script>

<style>
.el-collapse-item__header {
	/* display: flex; */
	align-items: center;
	height: 48px;
	line-height: 48px;
	margin-left: 10px;
	cursor: pointer;
	font-size: 13px;
	/* font-weight: 500; */
	transition: border-bottom-color 0.3s;
	outline: 0;
}
.demo-table-expand {
	font-size: 0;
}
.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}
.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}
</style>
